// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fZZ1m","toggleWrap":"styles_toggleWrap__NCLr5","content":"styles_content__XWblW","selectAreaCode":"styles_selectAreaCode__1ak9v"};